export const MODULE_NAME = 'lk-mun-meh-form-review-second'

export const LK_MUN_MEH_FORM_REVIEW_SECOND_ROUTES = {
  LAYOUT: MODULE_NAME,
  FORM: `${MODULE_NAME}.review.form`,
  ANY_LEVEL: `${MODULE_NAME}.form.level`,
} as const
